export const PRIMARY = '#1779ba';
export const SECONDARY = '#cc4b37';
export const WHITE = '#F9F9F9';
export const BLACK = '#252525';
export const TEXTOBOTAO = '#FFFFFF';
export const SECONDARY_PALLETE = ['#cc4b37', '#d15d4b', '#d67060']
export const SNOW = "#fffafa"
// ACTIONS
export const SUCCESS = '#3adb76';
export const WARNING = '#ffae00';
export const ALERT = '#cc4b37';
export const INFO = '#4682B4';


//CREDIT CARD
export const CHIP = '#e9a001';

// GRAYSCALE
export const GRAY_LIGHT = '#e6e6e6';
export const GRAY_MEDIUM = '#dddddd';
export const GRAY_DARK = '#8a8a8a';
export const LICENSE_PLATE = "#b6bfc5";

// MODAL
export const MODAL = '#FFFFFF';

//LOGIN
export const WELCOME_TEXT = '#5a5b6d';
export const PLACE_HOLDER_TEXT_COLOR = '#003f5c';
export const INPUT_BORDER_COLOR = '#969696';

//MAP
export const CIRCLE_BORDER = "#3399ff"
export const CIRCLE_COLOR = "rgba(0, 0, 200, 0.2)"

//HYPERLINK
export const HYPERLINK = "#3366CC"

//TICKET
export const TICKET = "#ede985"

//MONEY
export const CASH = "#036704"

export const WALLET = "#7d2b00"
export const WALLET_SECONDARY = "#9c3600"

//ONBOARDING
export const IMAGE_OVERLAYED = '#0000008A'